export enum EFooterBlockType {
  Logo = 'logo',
  Images = 'images',
  Text = 'text',
  Links = 'links',
  Payments = 'payments',
  Default = 'default',
}

export const FOOTER_BLOCK_TYPE_OPTIONS: {
  name: string;
  value: EFooterBlockType;
  icon: string;
}[] = [
  { name: 'Standard', value: EFooterBlockType.Default, icon: 'crop_square' },
  { name: 'Logo', value: EFooterBlockType.Logo, icon: 'image' },
  { name: 'Freitext', value: EFooterBlockType.Text, icon: 'font_download' },
  { name: 'Link-Liste', value: EFooterBlockType.Links, icon: 'list_alt' },
  { name: 'Bild-Liste', value: EFooterBlockType.Images, icon: 'filter' },
  { name: 'Zahlungsarten', value: EFooterBlockType.Payments, icon: 'payments' },
];

export type FooterAreaKey =
  | 'logoArea'
  | 'addressArea'
  | 'paymentArea'
  | 'linkArea';

export const DEFAULT_FOOTER_AREA_TYPE: Record<FooterAreaKey, EFooterBlockType> =
  {
    logoArea: EFooterBlockType.Logo,
    addressArea: EFooterBlockType.Text,
    paymentArea: EFooterBlockType.Payments,
    linkArea: EFooterBlockType.Links,
  };

export function toFooterBlockType(
  type: string | undefined,
  fallback: EFooterBlockType
): EFooterBlockType {
  if (type === 'logo' || type === EFooterBlockType.Logo) {
    return EFooterBlockType.Logo;
  }

  if (
    type === EFooterBlockType.Images ||
    type === EFooterBlockType.Text ||
    type === EFooterBlockType.Links ||
    type === EFooterBlockType.Payments ||
    type === EFooterBlockType.Default
  ) {
    return type;
  }

  return fallback;
}
